import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MerchantListFilters } from '../types/merchantListFilters';

export type MerchantListFiltersState = {
  filters: MerchantListFilters;
  // null until the first response, so an unloaded list is never shown as an empty one.
  total: number | null;
};

const initialState: MerchantListFiltersState = { filters: {}, total: null };

const merchantListFiltersSlice = createSlice({
  name: 'merchantListFilters',
  initialState,
  reducers: {
    setMerchantListFilters: (state, action: PayloadAction<MerchantListFilters>) => {
      state.filters = action.payload;
    },
    setMerchantListFilter: (
      state,
      action: PayloadAction<{ key: keyof MerchantListFilters; value: MerchantListFilters[keyof MerchantListFilters] }>,
    ) => {
      const { key, value } = action.payload;
      if (value === undefined || value === '') {
        delete state.filters[key];
      } else {
        Object.assign(state.filters, { [key]: value });
      }
    },
    setMerchantListTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    resetMerchantListFilters: state => {
      state.filters = {};
    },
  },
});

export const { actions: merchantListFiltersActions, reducer: merchantListFiltersReducer } = merchantListFiltersSlice;
export const { setMerchantListFilters, setMerchantListFilter, setMerchantListTotal, resetMerchantListFilters } =
  merchantListFiltersActions;
